// import { useAppDispatch } from '@store/hooks';
// import { useFormik } from 'formik';
// import { useTranslation } from 'react-i18next';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import { Form } from 'react-bootstrap';
// import Loading from '@components/Shared/Loader/Loading';
// import Select from 'react-select';
// import useGlChartLookups from '@hooks/Finance/ChartAccountsDetails/useGlChartLookups';
// import {
//   addApExpenseCategoryItems,
//   GetApExpenseCategoryItemsByExpenseCategoryId
// } from '@store/Finance/Expense/ApExpenseCategoryItems/ExpenseCategoryItemsSlice';

// import { AddApExpenseCategoryItemsSchema } from '../../../../ValidationForm/validationSchema';

// interface props {
//   expenseCategoryId?: string;
// }

// const AddExpenseCategoryItems = ({ expenseCategoryId }: props) => {
//   const { i18n, t } = useTranslation();
//   const dispatch = useAppDispatch();

//   const { OptionsAccounts, loading, error } = useGlChartLookups();

//   const formik = useFormik({
//     initialValues: {
//       expenseCategoryId: '',
//       name: '',
//       name2: '',
//       accountId: null
//     },
//     validationSchema: AddApExpenseCategoryItemsSchema(t),
//     onSubmit: values => {
//       dispatch(
//         addApExpenseCategoryItems({
//           expenseCategoryId: expenseCategoryId,
//           name: values.name,
//           name2: values.name2,
//           accountId: values.accountId
//         })
//       )
//         .unwrap()
//         .then((res: any) => {
//           // debugger
//           if (res?.succeeded === true) {
//             CustomAlert({ action: 'Add' });
//             dispatch(GetApExpenseCategoryItemsByExpenseCategoryId(expenseCategoryId ?? ''));
//             formik.resetForm();
//           } else {
//             formik.setSubmitting(false);
//             CustomAlert({ action: 'Error', msg: res?.message });
//           }
//         })
//         .catch((error: any) => {
//           formik.setSubmitting(false);
//           CustomAlert({ action: 'Error' });
//         });
//     }
//   });

//   // console.log(formik.errors);

//   return (
//     <>
//       <Loading loading={false} error={null}>
//         <Form onSubmit={formik.handleSubmit}>
//           <div className='row align-items-end'>
//             <div className='col-xl-6'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('LocalName')}</label>
//                 <Form.Control
//                   className='form-control  '
//                   type='text'
//                   autoComplete='off'
//                   name='name2'
//                   onChange={formik.handleChange}
//                   value={formik.values.name2}
//                   isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
//                 />
//               </div>
//             </div>
//             <div className='col-xl-6'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('GlobalName')}</label>
//                 <Form.Control
//                   className='form-control  '
//                   type='text'
//                   autoComplete='off'
//                   name='name'
//                   onChange={formik.handleChange}
//                   value={formik.values.name}
//                   isInvalid={!!(formik.touched.name && formik.errors.name)}
//                 />
//               </div>
//             </div>

//             <div className='col-xl-12'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('Account')}</label>
//                 <Select
//                   classNamePrefix='react-select'
//                   // className="text-center"
//                   // isLoading={loadingAccounts}
//                   isSearchable={true}
//                   isClearable
//                   options={OptionsAccounts}
//                   value={OptionsAccounts?.find(f => f.value === formik.values.accountId)}
//                   onChange={option => formik.setFieldValue('accountId', option?.value)}
//                   placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                 />
//                 <div className='text-danger small'>{formik.touched.accountId && formik.errors.accountId}</div>
//               </div>
//             </div>

//             <div className='col-xl-4 text-end  '>
//               <div className=' form-group mb-3 d-flex justify-content-end '>
//                 <button disabled={formik.isSubmitting} type='submit' className='btn me-1 btn-theme w-100'>
//                   {formik.isSubmitting ? (
//                     <div className='spinner-border spinner-border-sm me-2'></div>
//                   ) : (
//                     <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
//                   )}
//                   {t('Add')}
//                 </button>
//                 <button
//                   type='button'
//                   className=' btn me-1 btn-default w-100'
//                   data-bs-dismiss='modal'
//                   id='closeModalForm'
//                 >
//                   <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </Form>
//       </Loading>
//     </>
//   );
// };

// export default AddExpenseCategoryItems;


import { useAppDispatch } from '@store/hooks';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { Form } from 'react-bootstrap';
import Loading from '@components/Shared/Loader/Loading';
import Select from 'react-select';
import useGlChartLookups from '@hooks/Finance/ChartAccountsDetails/useGlChartLookups';
import {
  addApExpenseCategoryItems,
  GetApExpenseCategoryItemsByExpenseCategoryId,
  updateApExpenseCategoryItems
} from '@store/Finance/Expense/ApExpenseCategoryItems/ExpenseCategoryItemsSlice';

import { AddApExpenseCategoryItemsSchema } from '../../../../ValidationForm/validationSchema';

interface Props {
  expenseCategoryId?: string;
  editingItem?: any | null;
  onCancelEdit?: () => void;
}

const AddExpenseCategoryItems = ({ expenseCategoryId, editingItem, onCancelEdit }: Props) => {
  const { i18n, t } = useTranslation();
  const dispatch = useAppDispatch();

  const { OptionsAccounts } = useGlChartLookups();
  const isEdit = !!editingItem?.id;

  const formik = useFormik({
    initialValues: {
      id: editingItem?.id ?? '',
      expenseCategoryId: expenseCategoryId ?? editingItem?.expenseCategoryId ?? '',
      name: editingItem?.name ?? '',
      name2: editingItem?.name2 ?? '',
      accountId: editingItem?.accountId ?? null
    },
    enableReinitialize: true,
    validationSchema: AddApExpenseCategoryItemsSchema(t),
    onSubmit: values => {
      const catId = (expenseCategoryId ?? values.expenseCategoryId) as string;

      if (!catId) {
        formik.setSubmitting(false);
        CustomAlert({ action: 'Error', msg: 'Expense Category is required' });
        return;
      }

      const action = isEdit
        ? updateApExpenseCategoryItems({
            id: values.id || editingItem?.id,
            expenseCategoryId: catId,
            name: values.name,
            name2: values.name2,
            accountId: values.accountId
          })
        : addApExpenseCategoryItems({
            expenseCategoryId: catId,
            name: values.name,
            name2: values.name2,
            accountId: values.accountId
          });

      dispatch(action)
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: isEdit ? 'Edit' : 'Add' });
            dispatch(GetApExpenseCategoryItemsByExpenseCategoryId(catId ?? ''));

            // ✅ back to add-mode after edit
            if (isEdit) onCancelEdit?.();

            formik.resetForm();
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch(() => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  return (
    <>
      <Loading loading={false} error={null}>
        <Form onSubmit={formik.handleSubmit}>
          <div className='d-flex align-items-center justify-content-between mb-2'>
            <div className='d-flex align-items-center'>
              <i className={`fa fa-fw me-2 ${isEdit ? 'fa-edit' : 'fa-plus'}`}></i>
              <strong>{isEdit ? t('Button.Edit') : t('Add')}</strong>
            </div>

            {isEdit ? (
              <button type='button' className='btn btn-sm btn-default' onClick={() => onCancelEdit?.()}>
                <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
              </button>
            ) : null}
          </div>

          <div className='row align-items-end'>
            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('LocalName')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='name2'
                  onChange={formik.handleChange}
                  value={formik.values.name2}
                  isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
                />
              </div>
            </div>

            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('GlobalName')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='name'
                  onChange={formik.handleChange}
                  value={formik.values.name}
                  isInvalid={!!(formik.touched.name && formik.errors.name)}
                />
              </div>
            </div>

            <div className='col-xl-12'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Account')}</label>
                <Select
                  classNamePrefix='react-select'
                  isSearchable={true}
                  isClearable
                  // isDisabled={isEdit}
                  options={OptionsAccounts}
                  value={OptionsAccounts?.find((f: any) => f.value === formik.values.accountId)}
                  onChange={(option: any) => formik.setFieldValue('accountId', option?.value)}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                />
                <div className='text-danger small'>
                  {formik.touched.accountId && (formik.errors as any).accountId}
                </div>
              </div>
            </div>

            <div className='col-xl-4 text-end'>
              <div className='form-group mb-3 d-flex justify-content-end'>
                <button disabled={formik.isSubmitting} type='submit' className='btn me-1 btn-theme w-100'>
                  {formik.isSubmitting ? (
                    <div className='spinner-border spinner-border-sm me-2'></div>
                  ) : isEdit ? (
                    <i className='fa fa-save fa-fw me-2'></i>
                  ) : (
                    <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
                  )}
                  {isEdit ? t('Save') : t('Add')}
                </button>

                {!isEdit ? (
                  <button type='button' className='btn me-1 btn-default w-100' onClick={() => formik.resetForm()}>
                    <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        </Form>
      </Loading>
    </>
  );
};

export default AddExpenseCategoryItems;
